import script from "./product-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./product-detail.vue?vue&type=script&setup=true&lang=js"

import "./product-detail.vue?vue&type=style&index=0&id=15c00f19&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Astig_Counter_tFv5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c00f19"]])

export default __exports__